module.exports = __webpack_public_path__ + "assets/img/busy_2.fd866bc0.png";